import React from 'react';
import './styles.scss';

interface SearchQueryProps {
  query: string | null;
  onChange: (query: string | null) => void;
}

// @todo: throttle
export default function SearchQuery(props: SearchQueryProps): JSX.Element {
  return (
    <div className="search-query-bar">
      <div className="form-group">
        <label>Keywords</label>
      </div>
      <div className="query-wrapper">
        <input
          className="form-control"
          type="text"
          placeholder="Search by keyword..."
          value={props.query ?? ''}
          onChange={e => props.onChange(e.target.value ?? null)}
        />
        <button
          className="close"
          aria-label="Clear"
          type="button"
          onClick={e => props.onChange(e.currentTarget.value ?? null)}
        >
          <span aria-hidden="true">×</span>
          <span className="sr-only">Clear</span>
        </button>
      </div>
    </div>
  );
}
